import { render, staticRenderFns } from "./SfIcon.vue?vue&type=template&id=2f4012a6&"
import script from "./SfIcon.vue?vue&type=script&lang=js&"
export * from "./SfIcon.vue?vue&type=script&lang=js&"
import style0 from "./SfIcon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports